import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import "aframe";
import "components/maps/MapModal.css";
import Minimap from "components/maps/Minimap";
import api from "api"; // Substituição do axios pelo api
import { Screenshot } from "components/screenshot/Screenshot";
import "bootstrap/dist/css/bootstrap.min.css";
import "../projects/TourVirtual.css";
import Compass from "components/compass/Compass"; // Importação do componente Compass

function TourVirtual({ email, token }) {
  const [images, setImages] = useState([]);
  const [currentScene, setCurrentScene] = useState(null);
  const [activeMarkerIndex, setActiveMarkerIndex] = useState(null);
  const [loadingImage, setLoadingImage] = useState(false);
  const [rotation, setRotation] = useState(0); // Estado para rotação da bússola

  const location = useLocation();
  const navigate = useNavigate();
  const { project, date } = location.state || {};
  const { name } = project || {};

  const skyRef = useRef(null);
  const { folder_path: folderPathFromState } = location.state || {};
  const folder_path = folderPathFromState || `projetos/${name}/${date}/tour_360`;

  useEffect(() => {
    const loadImages = async () => {
      if (!email || !name || !date) return;

      setLoadingImage(true);
      try {
        const response = await api.post(
          "/projects/list_files",
          { folder_path },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );

        const imageList = response.data.files.map(file => ({
          src: file.url,
          fileName: extractFileName(file.url),
          latitude: convertDMSToDD(file.gps.latitude, file.gps.latitude_ref),
          longitude: convertDMSToDD(file.gps.longitude, file.gps.longitude_ref)
        }));

        setImages(imageList);
        setCurrentScene(imageList[0] || null);
      } catch (error) {
        console.error("Erro ao carregar imagens:", error);
      } finally {
        setLoadingImage(false);
      }
    };

    loadImages();
  }, [email, name, date, token, folder_path]);

  useEffect(() => {
    if (currentScene && skyRef.current) {
      setLoadingImage(true);
      skyRef.current.addEventListener("materialtextureloaded", handleImageLoad);
    }
    return () => {
      const skyNode = skyRef.current;
      if (skyNode) {
        skyNode.removeEventListener("materialtextureloaded", handleImageLoad);
      }
    };
  }, [currentScene]);

  const handleImageLoad = () => {
    setLoadingImage(false);
  };

  const handleMarkerClick = index => {
    setLoadingImage(true);
    setCurrentScene(images[index]);
    setActiveMarkerIndex(index);
  };

  function extractFileName(url) {
    return url.substring(url.lastIndexOf("/") + 1);
  }

  function convertDMSToDD(value, ref) {
    return ref === "S" || ref === "W" ? -Math.abs(value) : Math.abs(value);
  }

  // Função para atualizar a rotação da bússola
  const updateCompassRotation = () => {
    const camera = document.querySelector("a-entity[camera]");
    if (camera) {
      const rotationY = camera.getAttribute("rotation").y; // A rotação no eixo Y da câmera
      setRotation(rotationY);
    }
  };

  useEffect(() => {
    const interval = setInterval(updateCompassRotation, 100); // Atualiza a rotação a cada 100ms
    return () => clearInterval(interval);
  }, []);

  const ref = useRef(null);

  const handleCloseTour = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/projects", { state: name ? { openProject: name } : undefined });
    }
  };

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100%",
        height: "100%"
      }}
    >
      {/* Botão para fechar */}
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          zIndex: 2,
          padding: "10px"
        }}
      >
        <div className="QuitButtonTour">
          <button type="button" title="Voltar" onClick={handleCloseTour}>&times;</button>
        </div>
      </div>

      <Screenshot tagReference={ref} folderPath={folder_path} variant="tour-virtual" />

      <form>
        <div>
          <div style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}>
            <a-scene
              embedded
              style={{ width: "100%", height: "100%" }}
              ref={ref}
            >
              {loadingImage && (
                <div className="d-flex justify-content-center align-items-center vh-100">
                  <div className="spinner-border" role="status"></div>
                </div>
              )}
              {currentScene && (
                <>
                  <a-sky
                    ref={skyRef}
                    src={currentScene.src}
                    rotation="0 -90 0"
                  ></a-sky>
                  <a-entity
                    camera
                    look-controls
                    wasd-controls="acceleration:1000000000"
                    position="0 1.6 0"
                  ></a-entity>
                  <a-light
                    type="ambient"
                    position="0 5 0"
                    intensity="0.5"
                  ></a-light>
                  <a-light
                    type="directional"
                    position="-3 3 1"
                    intensity="0.5"
                  ></a-light>
                </>
              )}
            </a-scene>
            {!loadingImage && images.length > 0 && (
              <div className="custom-mini">
                <Minimap
                  images={images}
                  onMarkerClick={handleMarkerClick}
                  activeMarker={activeMarkerIndex}
                />
                <div className="mt-10">
                  <Compass rotation={rotation} />
                </div>
              </div>
            )}
          </div>
        </div>
      </form>
    </div>
  );
}

const mapStateToProps = state => ({
  email: state.auth.email,
  token: state.auth.accessToken
});

export default connect(mapStateToProps)(TourVirtual);
